import script from "./TableLeadPropertyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TableLeadPropertyComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__